/**
 * External Dependencies
 */
import 'jquery';
import 'slick-carousel/slick/slick.min.js';
import 'magnific-popup/dist/jquery.magnific-popup.min.js';

$(document).ready(() => {
  $('.navbar-burger').on('click', function(e) {
    e.preventDefault();
    if($('.navbar-menu').hasClass('active-menu')) {
      $('.navbar-menu').removeClass('active-menu');
    }
    else {
      $('.navbar-menu').addClass('active-menu');
    }
  });


  // slide navigation scrolls
  $(".step-anchor-link").on('click', function(e) {
    e.preventDefault();
    var id = $(this).data('id');
    $('html,body').animate({scrollTop: $(id).offset().top},'slow');
  });

  // logo list scroll
  $(".top-step-anchor").on('click', function(e) {
    e.preventDefault();
    var id = $(this).data('id');
    $('html,body').animate({scrollTop: $(id).offset().top},'slow');
  });

  // scroll to first display slide
  $('.next-slide').on('click', function(e) {
    e.preventDefault();
    var id = '.presentation-slide';
    $('html,body').animate({scrollTop: $(id).offset().top},'slow');
  });

  // scroll to next display slide
  $('.next-slide-id').on('click', function(e) {
    e.preventDefault();
    $(this).closest('div').nextAll(':has(.class):first').find('.presentation-slide').css('background', 'red');
    var parent = '#' + $(this).parent().parent().attr('id');
    var next = '#' + $(parent).next('.presentation-slide').attr('id');
    $('html,body').animate({scrollTop: $(next).offset().top},'slow');
  });

  $('.scroll-to-next').on('click', function(e) {
    e.preventDefault();
    var id = '.scroll-lower-container';
    $('html,body').animate({scrollTop: $(id).offset().top},'slow');
  });


  $('.usage-slider-container').slick({
    dots: false,
    arrows: false,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    prevArrow:"<button type='button' class='slick-prev pull-left'><i class='far fa-chevron-circle-left'></i></button>",
    nextArrow:"<button type='button' class='slick-next pull-right'><i class='far fa-chevron-circle-right'></i></button>",

    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          infinite: true,
          dots: false,
          arrows: true
        }
      },
    ]
  });

  $('.is-openable-image').on('click', function(e) {
    e.preventDefault();
    console.log('jee');
    $(this).find('a').magnificPopup({
      delegate: 'a', // child items selector, by clicking on it popup will open
      type: 'image'
      // other options
    });
  });

  $('.open-img-link').magnificPopup({
    type: 'image',
  });


});
